import { Component, OnDestroy, OnInit } from '@angular/core';
import { JSONSchema7 } from 'json-schema';
import { userPages } from '../user.routes';
import { ProjectDto } from '@api/projects/interfaces';
import { Router } from '@angular/router';
import { SessionItemData } from '../../../workflow/services/session-item-data';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';
import { InterpolationService } from '../../../services/interpolation/interpolation.service';
import userSchema from '../userSchema.json';
import { UserRestService } from '../../../services/rest/user-rest.service';
import { UserPasswordDto } from '@api/users/interfaces';
import { ProjectService } from '@app/services/project/project.service';
import { MenuService } from '@app/services/menu';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ErrorNotificationService } from '@app/services/error-notification/error-notification.service';


@Component({
	selector: 'app-user-create',
	templateUrl: './user-create.component.html',
	styleUrls: ['../user-pages.style.scss'],
})
export class UserCreateComponent implements OnInit, OnDestroy {
	activeProject: ProjectDto = null;
	
	data: SessionItemData = new SessionItemData();
	userFormID = 'form-create-user';
	readonly = false;
	resolvedSchema: JSONSchema7 = userSchema as JSONSchema7;
	
	public userAddSplitButton: SplitButtonElement = {
		title: 'actions.save',
		icon: 'save',
		type: 'primary',
		buttonType: 'submit',
		attrForm: this.userFormID,
	};
	public userCancelSplitButton: SplitButtonElement = {
		title: 'actions.cancel',
		icon: 'x',
		type: 'default',
		callback: () => this.showUserList(),
	};
	
	constructor(
		private router: Router,
		private interpolationService: InterpolationService,
		private userRestService: UserRestService,
		private projectService: ProjectService,
		private notification: NzNotificationService,
		private errorService: ErrorNotificationService,
		private menuService: MenuService,
	) {
	}
	
	ngOnInit(): void {
		//this.fillRoles();
		this.menuService.title = 'actions.new.user';
	}
	
	ngOnDestroy(): void {}
	
	async createNewUser(isFormValid: boolean): Promise<void> {
		if (!isFormValid) {
			return;
		}
		
		const userData = this.data.getProperty('userData');
		if (userData.password !== userData.password_confirm) {
			this.notification.error('', 'Die Passwörter stimmen nicht überein.');
			return;
		}
		const dto: UserPasswordDto = {
			username: userData.username,
			name: userData.name,
			email: userData.email,
			password: userData.password,
			disabled: false,
			roles: undefined,
		};
		
		try {
			const user = await this.userRestService.createUser(dto);
			this.notification.success('', `Benutzer ${user.username} erfolgreich angelegt`);
			this.showUserList();
		} catch (error) {
			this.errorService.showErrorNotification(error);
		}
	}
	
	public showUserList(): void {
		this.router
			.navigate([userPages.dashboard.base()])
			.catch(console.error);
	}
	
	setSubmitActive(active: boolean): void {
		this.userAddSplitButton.disabled = !active;
	}
	
}
